import { useEffect, useState } from "react";
import { Loader2, RefreshCw } from "lucide-react";
import { Button } from "./button";
import { logger } from '@/lib/logger';

interface PageLoaderProps {
  message?: string;
}

export const PageLoader = ({ message = "Chargement..." }: PageLoaderProps) => {
  const [showRecovery, setShowRecovery] = useState(false);

  useEffect(() => {
    // Si le chargement prend plus de 8 secondes, afficher les options de récupération
    const timeout = setTimeout(() => {
      setShowRecovery(true);
    }, 8000);

    return () => clearTimeout(timeout);
  }, []);

  const handleForceRefresh = async () => {
    try {
      // Désinscrire tous les service workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(reg => reg.unregister()));
      }
      
      // Vider tous les caches
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }
      
      // Nettoyer le localStorage des clés PWA
      localStorage.removeItem('app-build-version');
      localStorage.removeItem('app-last-reload');
      
      // Forcer le rechargement complet
      window.location.href = window.location.origin + '?nocache=' + Date.now();
    } catch (e) {
      logger.error('Erreur lors du rafraîchissement:', e);
      window.location.reload();
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
        <p className="text-muted-foreground text-sm animate-pulse">{message}</p>
        
        {showRecovery && (
          <div className="mt-6 flex flex-col items-center gap-3 animate-fade-in">
            <p className="text-sm text-muted-foreground text-center max-w-xs">
              Le chargement prend plus de temps que prévu.
            </p>
            <Button
              onClick={handleForceRefresh}
              variant="outline"
              size="sm"
              className="gap-2"
            >
              <RefreshCw className="h-4 w-4" />
              Rafraîchir l'application
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
